import { useTranslation } from "react-i18next";

import { DomainCycle } from "../../services/domains";
import { Cycles } from "./styles";

type Props = {
  cycles: DomainCycle[];
  selected: number;
  onSelect: (years: number) => void;
  formatBRL: (value: number) => string;
};

/** The cycles sold (1, 2, 5 years) side by side, to pick one (a radio on the left of each): the full price struck through with the saving, the price, "for N years". */
export const CycleOptions = ({ cycles, selected, onSelect, formatBRL }: Props) => {
  const { t } = useTranslation();
  return (
    <Cycles role="radiogroup" aria-label={t("pages.domains.cycles.label")}>
      {cycles.map(cycle => {
        const discount = cycle.fullPrice > cycle.price ? Math.round((1 - cycle.price / cycle.fullPrice) * 100) : 0;
        return (
          <button
            key={cycle.years}
            type="button"
            role="radio"
            aria-checked={selected === cycle.years}
            onClick={() => onSelect(cycle.years)}>
            <span className="radio" aria-hidden="true" />
            <span className="info">
              {/* Only with a discount (an empty struck-through line showed as a dash): the full price, then the saving */}
              {discount > 0 && (
                <span className="was">
                  <s>{formatBRL(cycle.fullPrice)}</s>
                  <span className="off">-{discount}%</span>
                </span>
              )}
              <b>{formatBRL(cycle.price)}</b>
              <span className="years">{t("pages.domains.cycles.years", { count: cycle.years })}</span>
            </span>
          </button>
        );
      })}
    </Cycles>
  );
};
